// Bun Mystery theme — vanilla JS port of the React interactions.
(function () {
  "use strict";

  /* ---------------- Header scroll state ---------------- */
  const header = document.querySelector("[data-site-header]");
  if (header) {
    const onScroll = () => {
      if (window.scrollY > 12) {
        header.classList.add("bg-cream/90", "backdrop-blur-md", "shadow-[0_4px_0_0_rgba(74,51,25,0.08)]");
        header.classList.remove("bg-transparent");
      } else {
        header.classList.remove("bg-cream/90", "backdrop-blur-md", "shadow-[0_4px_0_0_rgba(74,51,25,0.08)]");
        header.classList.add("bg-transparent");
      }
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---------------- Mobile menu ---------------- */
  const menuToggle = document.querySelector("[data-mobile-menu-toggle]");
  const mobileMenu = document.querySelector("[data-mobile-menu]");
  const iconOpen = document.querySelector("[data-mobile-menu-icon-open]");
  const iconClose = document.querySelector("[data-mobile-menu-icon-close]");
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener("click", () => {
      const isOpen = !mobileMenu.classList.contains("hidden");
      mobileMenu.classList.toggle("hidden", isOpen);
      mobileMenu.classList.toggle("flex", !isOpen);
      menuToggle.setAttribute("aria-expanded", String(!isOpen));
      menuToggle.setAttribute(
        "aria-label",
        isOpen ? menuToggle.dataset.openLabel : menuToggle.dataset.closeLabel
      );
      if (iconOpen) iconOpen.classList.toggle("hidden", !isOpen);
      if (iconClose) iconClose.classList.toggle("hidden", isOpen);
    });
  }

  /* ---------------- Scroll reveal (mirrors useReveal hook) ---------------- */
  const revealEls = document.querySelectorAll(".reveal");
  if (revealEls.length && "IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    revealEls.forEach((el) => observer.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add("is-visible"));
  }

  /* ---------------- FAQ accordion ---------------- */
  document.querySelectorAll("[data-accordion-item]").forEach((item) => {
    const trigger = item.querySelector("[data-accordion-trigger]");
    if (!trigger) return;
    trigger.addEventListener("click", () => {
      const isOpen = item.classList.contains("is-open");
      item.closest("[data-accordion-item]")
        .parentElement.querySelectorAll("[data-accordion-item]")
        .forEach((el) => {
          if (el !== item) {
            el.classList.remove("is-open");
            el.querySelector("[data-accordion-trigger]").setAttribute("aria-expanded", "false");
          }
        });
      item.classList.toggle("is-open", !isOpen);
      trigger.setAttribute("aria-expanded", String(!isOpen));
    });
  });

  /* ---------------- Product gallery thumbnails ---------------- */
  document.querySelectorAll("[data-gallery-thumb]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const main = document.querySelector("[data-gallery-main]");
      const src = btn.getAttribute("data-full-src");
      if (main && src) {
        main.src = src;
        main.classList.remove("animate-pop-in");
        void main.offsetWidth;
        main.classList.add("animate-pop-in");
      }
      btn.parentElement.querySelectorAll("[data-gallery-thumb]").forEach((b) => {
        b.classList.remove("border-blush-500");
        b.classList.add("border-bamboo-200");
      });
      btn.classList.remove("border-bamboo-200");
      btn.classList.add("border-blush-500");
    });
  });

  /* ---------------- Product variant picker ---------------- */
  document.querySelectorAll("[data-variant-picker]").forEach((picker) => {
    const form = picker.closest("form");
    const hiddenInput = form ? form.querySelector("[data-selected-variant-id]") : null;
    const totalPrice = form ? form.querySelector("[data-total-price]") : null;
    const savingsBadge = form ? form.querySelector("[data-savings-badge]") : null;
    const savingsAmount = form ? form.querySelector("[data-savings-amount]") : null;

    const selectVariant = (btn) => {
      picker.querySelectorAll("[data-variant-option]").forEach((b) => {
        b.classList.remove("border-blush-500", "bg-blush-100/60");
        b.classList.add("border-bamboo-200", "bg-cream");
      });
      btn.classList.remove("border-bamboo-200", "bg-cream");
      btn.classList.add("border-blush-500", "bg-blush-100/60");

      const price = parseInt(btn.getAttribute("data-variant-price"), 10);
      const compareAt = parseInt(btn.getAttribute("data-variant-compare-at"), 10) || 0;

      if (hiddenInput) hiddenInput.value = btn.getAttribute("data-variant-id");
      if (totalPrice) totalPrice.textContent = formatMoney(price);

      if (savingsBadge && savingsAmount) {
        if (compareAt > price) {
          savingsAmount.textContent = formatMoney(compareAt - price);
          savingsBadge.classList.remove("hidden");
        } else {
          savingsBadge.classList.add("hidden");
        }
      }
    };

    picker.querySelectorAll("[data-variant-option]").forEach((btn) => {
      btn.addEventListener("click", () => selectVariant(btn));
    });
  });

  function formatMoney(cents) {
    return (cents / 100).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + "€";
  }

  /* ---------------- Real AJAX cart ---------------- */
  const drawer = document.querySelector("[data-cart-drawer]");
  const backdrop = drawer ? drawer.querySelector("[data-cart-backdrop]") : null;
  const panel = drawer ? drawer.querySelector("[data-cart-panel]") : null;
  const body = drawer ? drawer.querySelector("[data-cart-body]") : null;
  const footer = drawer ? drawer.querySelector("[data-cart-footer]") : null;
  const subtotalEl = drawer ? drawer.querySelector("[data-cart-subtotal]") : null;
  const lineTemplate = document.getElementById("cart-line-template");
  const emptyTemplate = document.getElementById("cart-empty-template");
  const headerCount = document.querySelector("[data-cart-count]");

  function openCartDrawer() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.classList.remove("pointer-events-none");
    if (backdrop) backdrop.classList.add("opacity-100");
    if (panel) panel.classList.remove("translate-x-full");
    document.body.style.overflow = "hidden";
  }

  function closeCartDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    if (backdrop) backdrop.classList.remove("opacity-100");
    if (panel) panel.classList.add("translate-x-full");
    document.body.style.overflow = "";
    window.setTimeout(() => drawer.classList.add("pointer-events-none"), 400);
  }

  function routeUrl(path) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    return root.replace(/\/$/, "") + path;
  }

  async function refreshCart() {
    const res = await fetch(routeUrl("/cart.js"));
    const cart = await res.json();
    renderCart(cart);
    return cart;
  }

  function renderCart(cart) {
    if (headerCount) {
      headerCount.textContent = String(cart.item_count);
      headerCount.classList.toggle("hidden", cart.item_count === 0);
      headerCount.classList.toggle("flex", cart.item_count > 0);
    }

    if (!body) return;
    body.innerHTML = "";

    if (cart.item_count === 0) {
      if (emptyTemplate) body.appendChild(emptyTemplate.content.cloneNode(true));
      if (footer) footer.classList.add("hidden");
      return;
    }

    if (footer) footer.classList.remove("hidden");
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    cart.items.forEach((item) => {
      if (!lineTemplate) return;
      const node = lineTemplate.content.cloneNode(true);
      const img = node.querySelector("[data-line-image]");
      if (img) {
        if (item.image) {
          img.src = item.image.replace(/(\.[a-z]+)(\?|$)/i, "_120x120$1$2");
          img.alt = item.title;
        } else {
          img.remove();
        }
      }
      node.querySelector("[data-line-title]").textContent = item.product_title;
      const perUnitLabel = body.dataset.perUnit || "";
      node.querySelector("[data-line-price]").textContent = formatMoney(item.price) + " " + perUnitLabel;
      node.querySelector("[data-line-qty]").textContent = item.quantity;
      node.querySelector("[data-line-total]").textContent = formatMoney(item.final_line_price);

      node.querySelector("[data-line-decrease]").addEventListener("click", () => changeLine(item.key, item.quantity - 1));
      node.querySelector("[data-line-increase]").addEventListener("click", () => changeLine(item.key, item.quantity + 1));
      node.querySelector("[data-line-remove]").addEventListener("click", () => changeLine(item.key, 0));

      body.appendChild(node);
    });
  }

  async function changeLine(key, quantity) {
    await fetch(routeUrl("/cart/change.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity }),
    });
    refreshCart();
  }

  async function addToCart(form) {
    const formData = new FormData(form);
    const submitBtn = form.querySelector("[data-add-to-cart]");
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.classList.add("opacity-70");
    }
    try {
      const res = await fetch(routeUrl("/cart/add.js"), {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData,
      });
      if (!res.ok) throw new Error("add to cart failed");
      await refreshCart();
      openCartDrawer();
    } catch (err) {
      console.error(err);
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.classList.remove("opacity-70");
      }
    }
  }

  document.querySelectorAll("[data-product-form]").forEach((form) => {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      addToCart(form);
    });
  });

  document.querySelectorAll("[data-cart-open]").forEach((btn) => {
    btn.addEventListener("click", async () => {
      await refreshCart();
      openCartDrawer();
    });
  });
  document.querySelectorAll("[data-cart-close]").forEach((btn) => btn.addEventListener("click", closeCartDrawer));
  if (backdrop) backdrop.addEventListener("click", closeCartDrawer);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeCartDrawer();
  });

  /* ---------------- Unboxing carousel (drag-to-scroll + arrows + dots) ---------------- */
  document.querySelectorAll("[data-carousel]").forEach((root) => {
    const track = root.querySelector("[data-carousel-track]");
    const cards = Array.from(root.querySelectorAll("[data-carousel-card]"));
    const prevBtn = root.querySelector("[data-carousel-prev]");
    const nextBtn = root.querySelector("[data-carousel-next]");
    const dotsWrap = root.querySelector("[data-carousel-dots]");
    if (!track || !cards.length) return;

    let active = 0;
    const goToPhotoTemplate = track.dataset.goToPhotoLabel || "Go to photo __INDEX__";

    cards.forEach((_, i) => {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.setAttribute("aria-label", goToPhotoTemplate.replace("__INDEX__", String(i + 1)));
      dot.className = "h-2 rounded-full transition-all duration-300 " + (i === 0 ? "w-6 bg-blush-500" : "w-2 bg-bamboo-200");
      dot.addEventListener("click", () => scrollToIndex(i));
      dotsWrap && dotsWrap.appendChild(dot);
    });

    function updateUI() {
      if (prevBtn) prevBtn.disabled = active === 0;
      if (nextBtn) nextBtn.disabled = active === cards.length - 1;
      if (dotsWrap) {
        Array.from(dotsWrap.children).forEach((dot, i) => {
          dot.className = "h-2 rounded-full transition-all duration-300 " + (i === active ? "w-6 bg-blush-500" : "w-2 bg-bamboo-200");
        });
      }
    }

    function scrollToIndex(i) {
      const el = cards[i];
      if (!el) return;
      active = i;
      updateUI();
      el.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
    }

    function updateActiveFromScroll() {
      const maxScrollLeft = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft <= 2) {
        active = 0;
      } else if (track.scrollLeft >= maxScrollLeft - 2) {
        active = cards.length - 1;
      } else {
        const trackCenter = track.scrollLeft + track.clientWidth / 2;
        let closest = 0;
        let closestDist = Infinity;
        cards.forEach((el, i) => {
          const cardCenter = el.offsetLeft + el.offsetWidth / 2;
          const dist = Math.abs(cardCenter - trackCenter);
          if (dist < closestDist) {
            closestDist = dist;
            closest = i;
          }
        });
        active = closest;
      }
      updateUI();
    }

    let settleTimer;
    track.addEventListener(
      "scroll",
      () => {
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(updateActiveFromScroll, 100);
      },
      { passive: true }
    );

    if (prevBtn) prevBtn.addEventListener("click", () => scrollToIndex(Math.max(active - 1, 0)));
    if (nextBtn) nextBtn.addEventListener("click", () => scrollToIndex(Math.min(active + 1, cards.length - 1)));

    // Mouse drag-to-scroll, so desktop feels as fluid as a touch swipe.
    let isDragging = false;
    let startX = 0;
    let startScrollLeft = 0;

    track.addEventListener("pointerdown", (e) => {
      if (e.pointerType === "touch") return;
      e.preventDefault();
      isDragging = true;
      startX = e.clientX;
      startScrollLeft = track.scrollLeft;
      track.setPointerCapture(e.pointerId);
      track.classList.add("cursor-grabbing");
      track.classList.remove("snap-x");
      track.style.scrollBehavior = "auto";
    });

    track.addEventListener("pointermove", (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const delta = e.clientX - startX;
      track.scrollLeft = startScrollLeft - delta;
    });

    const endDrag = (e) => {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove("cursor-grabbing");
      track.classList.add("snap-x");
      track.style.scrollBehavior = "";
      if (e && e.pointerId !== undefined && track.hasPointerCapture && track.hasPointerCapture(e.pointerId)) {
        track.releasePointerCapture(e.pointerId);
      }
    };
    track.addEventListener("pointerup", endDrag);
    track.addEventListener("pointercancel", endDrag);

    updateUI();
  });

  /* ---------------- Locale suggestion banner ---------------- */
  (function initLocaleBanner() {
    const banner = document.querySelector("[data-locale-banner]");
    if (!banner) return;

    const COPY = {
      en: { message: "Looks like your browser prefers French.", switchLabel: "Switch to Français" },
      fr: { message: "On dirait que ton navigateur préfère l'anglais.", switchLabel: "Switch to English" },
    };

    const currentLang = (document.documentElement.lang || "en").slice(0, 2);
    const browserLang = (navigator.language || "en").slice(0, 2);
    const available = Object.keys(COPY);

    if (browserLang === currentLang || available.indexOf(browserLang) === -1) return;
    if (window.localStorage && localStorage.getItem("locale-banner-dismissed") === browserLang) return;

    const copy = COPY[currentLang];
    if (!copy) return;

    const messageEl = banner.querySelector("[data-locale-banner-message]");
    const switchBtn = banner.querySelector("[data-locale-banner-switch]");
    const dismissBtn = banner.querySelector("[data-locale-banner-dismiss]");
    if (messageEl) messageEl.textContent = copy.message;
    if (switchBtn) switchBtn.textContent = copy.switchLabel;

    const setOffset = () => {
      document.documentElement.style.setProperty("--locale-banner-h", banner.offsetHeight + "px");
    };
    const clearOffset = () => {
      document.documentElement.style.setProperty("--locale-banner-h", "0px");
    };

    banner.classList.remove("hidden");
    banner.classList.add("flex");
    setOffset();
    window.addEventListener("resize", setOffset);

    if (switchBtn) {
      switchBtn.addEventListener("click", () => {
        const select = document.querySelector("[data-language-switcher]");
        if (select) {
          select.value = browserLang;
          select.form.submit();
        }
      });
    }
    if (dismissBtn) {
      dismissBtn.addEventListener("click", () => {
        if (window.localStorage) localStorage.setItem("locale-banner-dismissed", browserLang);
        banner.classList.add("hidden");
        banner.classList.remove("flex");
        clearOffset();
        window.removeEventListener("resize", setOffset);
      });
    }
  })();
})();
